import React, { useState } from 'react';
import { useAppState } from '../../context/AppStateProvider';
import { Plus, Zap } from 'lucide-react';

const UtilityQuickCapture = () => {
  const { addItem, addLead, setCurrentView } = useAppState();
  const [quickTitle, setQuickTitle] = useState('');
  const [quickUrl, setQuickUrl] = useState('');
  const [quickType, setQuickType] = useState('tools');

  const handleQuickAdd = () => {
    if (quickTitle.trim() && quickUrl.trim()) {
      addItem(quickTitle.trim(), quickUrl.trim(), quickType);
      setQuickTitle('');
      setQuickUrl('');
    }
  };

  return (
    <div className="utility-section" data-testid="utility-quick-capture">
      <div className="utility-header">
        <Zap size={16} className="utility-icon" />
        <h3 className="utility-title">Quick Capture</h3>
      </div>
      <div className="quick-capture-form">
        <select
          value={quickType}
          onChange={(e) => setQuickType(e.target.value)}
          className="quick-select"
          data-testid="quick-type-select"
        >
          <option value="tools">Tool</option>
          <option value="prompts">Prompt</option>
          <option value="bookmarks">Bookmark</option>
        </select>
        <input
          type="text"
          value={quickTitle}
          onChange={(e) => setQuickTitle(e.target.value)}
          placeholder="Title"
          className="quick-input"
          data-testid="quick-title-input"
        />
        <input
          type="url"
          value={quickUrl}
          onChange={(e) => setQuickUrl(e.target.value)}
          placeholder="URL"
          className="quick-input"
          data-testid="quick-url-input"
        />
        <button 
          onClick={handleQuickAdd}
          className="quick-add-btn"
          data-testid="quick-add-btn"
        >
          <Plus size={16} />
          Add
        </button>
        <button
          onClick={() => setCurrentView('capture')}
          className="full-capture-link"
          data-testid="full-capture-link"
        >
          Full Capture →
        </button>
      </div>
    </div>
  );
};

export default UtilityQuickCapture;
